import { useEffect, useState } from 'react';

import { getLocalStorageItem, setLocalStorageItem } from 'src/utils';
import { AI_HINT_DISMISSED_KEY, AI_HINT_EXPIRY_HOURS } from './constants';

export default function useContextualActionsHint(enabled: boolean): {
  visible: boolean;
  close: () => void;
  stopShowing: () => void;
} {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setVisible(false);
      return;
    }
    if (getLocalStorageItem(AI_HINT_DISMISSED_KEY)) {
      return;
    }

    setVisible(true);
  }, [enabled]);

  // Nothing is stored: the hint comes back on the next narrative the user edits.
  const close = () => setVisible(false);

  const stopShowing = () => {
    setLocalStorageItem(AI_HINT_DISMISSED_KEY, '+', true, AI_HINT_EXPIRY_HOURS);
    setVisible(false);
  };

  return { visible, close, stopShowing };
}
